import { verifiedLinkAllows, verifiedLinkRecord } from '@cerebro-diem/core';

// Written when this tab verifies an invite or reset link, so a reload keeps the
// set-password form for that account (Safari reloads tabs it put to sleep).
// Without it the page shows no form: being signed in is not enough to change a
// password without the current one.
const KEY = 'cerebro.verifiedLink';

export function rememberVerifiedLink(userId: string): void {
  sessionStorage.setItem(KEY, verifiedLinkRecord(userId, Date.now()));
}

export function verifiedLinkAllowsPasswordForm(userId: string | null): boolean {
  return verifiedLinkAllows(sessionStorage.getItem(KEY), userId, Date.now());
}

export function forgetVerifiedLink(): void {
  sessionStorage.removeItem(KEY);
}
